/* import __COLOCATED_TEMPLATE__ from './line-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    openNewLineModal?: () => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const LineEmptyState = templateOnlyComponent<Signature>();
export default LineEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::LineEmptyState': typeof LineEmptyState;
  }
}
